import React from "react";
import { TextField } from "@material-ui/core";
import { useField } from "formik";
import { checkFormValidity } from "../../../src/utils/helpers";
import { WorkflowErrors } from "../../App";
import { InputAdornment, Tooltip } from "@material-ui/core";
import * as Icons from "@material-ui/icons";

export default function (props) {
  const [field, meta] = useField(props);
  const [taskErrors, setTaskErrors] = React.useContext(WorkflowErrors);

  React.useEffect(() => {
    // function to check the validity of the field
    checkFormValidity(field, meta, props, taskErrors, setTaskErrors);
  }, [field, meta, props]);

  const propsObj = { ...props };
  delete propsObj.taskReferenceName;
  return (
    <TextField
      autoComplete="off"
      required={propsObj.required}
      error={!!((meta.touched && meta.error) || (meta.value && meta.error))}
      helperText={
        meta.touched && meta.error
          ? meta.error
          : meta.value !== 0
          ? meta.value && meta.error
          : ""
      }
      {...field}
      {...propsObj}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <div className="flex-row" style={{ alignItems: "end" }}>
              {propsObj.tooltip ? (
                <Tooltip title={propsObj.tooltip} arrow>
                  <Icons.Help
                    style={{
                      verticalAlign: "middle",
                      fontSize: "16px",
                      marginLeft: "5px",
                      marginBottom: "5px",
                    }}
                    color="primary"
                  />
                </Tooltip>
              ) : null}
            </div>
          </InputAdornment>
        ),
      }}
    />
  );
}
